import React, { useEffect, useState } from "react";
import Api from "../../../../shared/api/api";
import AdminSidebar from "../components/AdminSidebar";
import "../styles/AdminCoupons.css";

export default function AdminCoupons() {
  const [coupons, setCoupons] = useState([]);
  const [loading, setLoading] = useState(true);

  // ----- Modal States -----
  const [showAdd, setShowAdd] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [selectedCoupon, setSelectedCoupon] = useState(null);

  const toggleEarlyAccess = async (coupon) => {
    await Api.updateCoupon(coupon.id, {
        ...coupon,
        allow_early_download: coupon.allow_early_download ? 0 : 1,
    });
    fetchCoupons();
  };
  const emptyForm = {
    code: "",
    description: "",
    discount_type: "fixed",
    amount: "",
    start_date: "",
    end_date: "",
    allow_early_download: false,
    active: true,
  };

  const [form, setForm] = useState(emptyForm);

  useEffect(() => {
    fetchCoupons();
  }, []);

  const fetchCoupons = async () => {
    try {
      const data = await Api.getCoupons();
      setCoupons(data.coupons || []);
    } catch (err) {
      console.error("Coupons load error:", err);
    } finally {
      setLoading(false);
    }
  };

  const updateField = (field, value) => {
    setForm((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  // ADD
  const saveAdd = async () => {
    await Api.addCoupon(form);
    setShowAdd(false);
    setForm(emptyForm);
    fetchCoupons();
  };

  // EDIT
  const openEdit = (coupon) => {
    setSelectedCoupon(coupon);
    setForm({
      code: coupon.code,
      description: coupon.description,
      discount_type: coupon.discount_type,
      amount: coupon.amount,
      start_date: coupon.start_date?.split("T")[0] || "",
      end_date: coupon.end_date?.split("T")[0] || "",
      allow_early_download: coupon.allow_early_download === 1,
      active: coupon.active === 1,
    });
    setShowEdit(true);
  };

  const saveEdit = async () => {
    await Api.updateCoupon(selectedCoupon.id, form);
    setShowEdit(false);
    setSelectedCoupon(null);
    fetchCoupons();
  };

  // DELETE
  const openDelete = (coupon) => {
    setSelectedCoupon(coupon);
    setShowDelete(true);
  };

  const confirmDelete = async () => {
    await Api.deleteCoupon(selectedCoupon.id);
    setShowDelete(false);
    setSelectedCoupon(null);
    fetchCoupons();
  };

  // TOGGLE ACTIVE
  const toggleActive = async (id) => {
    await Api.toggleCoupon(id);
    fetchCoupons();
  };

  return (
    <>
    <AdminSidebar />
    <div className="adminCouponsContainer">
      <h1 className="couponHeader">Coupons</h1>

      <button className="addBtn" onClick={() => setShowAdd(true)}>
        Add Coupon
      </button>

      {loading ? (
        <p>Loading...</p>
      ) : (
        <table className="couponTable">
          <thead>
            <tr>
              <th>Code</th>
              <th>Type</th>
              <th>Value</th>
              <th>Early Access</th>
              <th>Active</th>
              <th>Start</th>
              <th>End</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {coupons.map((c) => (
              <tr key={c.id}>
                <td>{c.code}</td>
                <td>{c.discount_type}</td>
                <td>
                  {c.discount_type === "percent"
                    ? `${c.amount}%`
                    : `$${c.amount}`}
                </td>
                <td className={`statusCell`}>
                     {/* EARLY ACCESS STATUS */}
                    <button
                        className={`earlyAccessBtn ${c.allow_early_download ? "earlyYes" : "earlyNo"}`}
                        onClick={() => toggleEarlyAccess(c)}
                        style={{ marginLeft: "8px" }}
                    >
                        {c.allow_early_download ? "Early" : "No Early"}
                    </button>
                </td>

                {/* ACTIVE TOGGLE BUTTON */}
                <td>
                  <button
                    className={`statusBtn ${c.active ? "activeStatus" : "inactiveStatus"}`}
                    onClick={() => toggleActive(c.id)}
                  >
                    {c.active ? "Active" : "Inactive"}
                  </button>
                </td>

                <td>{c.start_date?.split("T")[0] || "—"}</td>
                <td>{c.end_date?.split("T")[0] || "—"}</td>

                <td className="actionsCell">
                  <button className="editBtn" onClick={() => openEdit(c)}>
                    Edit
                  </button>
                  <button className="deleteBtn" onClick={() => openDelete(c)}>
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {/* ===== MODALS BELOW — ADD / EDIT / DELETE ===== */}

      {showAdd && (
        <div className="modalOverlay">
          <div className="modalBox">
            <h2>Add Coupon</h2>

            <div className="modalForm">
              <label>Code</label>
              <input
                type="text"
                value={form.code}
                onChange={(e) => updateField("code", e.target.value)}
              />

              <label>Description</label>
              <input
                type="text"
                value={form.description}
                onChange={(e) => updateField("description", e.target.value)}
              />

              <label>Type</label>
              <select
                value={form.discount_type}
                onChange={(e) => updateField("discount_type", e.target.value)}
              >
                <option value="fixed">Fixed</option>
                <option value="percent">Percent</option>
              </select>

              <label>Amount</label>
              <input
                type="number"
                value={form.amount}
                onChange={(e) => updateField("amount", e.target.value)}
              />

              <label>Start Date</label>
              <input
                type="date"
                value={form.start_date}
                onChange={(e) => updateField("start_date", e.target.value)}
              />

              <label>End Date</label>
              <input
                type="date"
                value={form.end_date}
                onChange={(e) => updateField("end_date", e.target.value)}
              />

              <label>
                <input
                  type="checkbox"
                  checked={form.allow_early_download}
                  onChange={(e) =>
                    updateField("allow_early_download", e.target.checked)
                  }
                />
                Allow Early Download
              </label>

              <label>
                <input
                  type="checkbox"
                  checked={form.active}
                  onChange={(e) => updateField("active", e.target.checked)}
                />
                Active
              </label>
            </div>

            <div className="modalActions">
              <button className="saveBtn" onClick={saveAdd}>
                Save
              </button>
              <button className="cancelBtn" onClick={() => setShowAdd(false)}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {showEdit && (
        <div className="modalOverlay">
          <div className="modalBox">
            <h2>Edit Coupon</h2>

            <div className="modalForm">
              <label>Code</label>
              <input
                type="text"
                value={form.code}
                onChange={(e) => updateField("code", e.target.value)}
              />

              <label>Description</label>
              <input
                type="text"
                value={form.description}
                onChange={(e) => updateField("description", e.target.value)}
              />

              <label>Type</label>
              <select
                value={form.discount_type}
                onChange={(e) => updateField("discount_type", e.target.value)}
              >
                <option value="fixed">Fixed</option>
                <option value="percent">Percent</option>
              </select>

              <label>Amount</label>
              <input
                type="number"
                value={form.amount}
                onChange={(e) => updateField("amount", e.target.value)}
              />

              <label>Start Date</label>
              <input
                type="date"
                value={form.start_date}
                onChange={(e) => updateField("start_date", e.target.value)}
              />

              <label>End Date</label>
              <input
                type="date"
                value={form.end_date}
                onChange={(e) => updateField("end_date", e.target.value)}
              />

              <label>
                <input
                  type="checkbox"
                  checked={form.allow_early_download}
                  onChange={(e) =>
                    updateField("allow_early_download", e.target.checked)
                  }
                />
                Allow Early Download
              </label>

              <label>
                <input
                  type="checkbox"
                  checked={form.active}
                  onChange={(e) => updateField("active", e.target.checked)}
                />
                Active
              </label>
            </div>

            <div className="modalActions">
              <button className="saveBtn" onClick={saveEdit}>
                Save
              </button>
              <button className="cancelBtn" onClick={() => setShowEdit(false)}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {showDelete && (
        <div className="modalOverlay">
          <div className="modalBox deleteBox">
            <h2>Delete Coupon</h2>
            <p>
              Are you sure you want to delete{" "}
              <strong>{selectedCoupon.code}</strong>?
            </p>

            <div className="modalActions">
              <button className="deleteConfirmBtn" onClick={confirmDelete}>
                Delete
              </button>
              <button className="cancelBtn" onClick={() => setShowDelete(false)}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
    </>
  );
}
